/* src/app/components/cbm-selector-item/cbm-selector-item.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.button {
  font-family: "Lato-Regular", serif;
  font-size: 18px;
  text-decoration: none;
  display: inline-block;
  margin: 5px;
  width: 290px;
  height: 50px;
  border-radius: 26px;
  border: none;
  padding: 10px;
  color: #5F96BA;
  outline: none !important;
}
.button:disabled {
  box-shadow: none;
  background-color: #BCBCBD !important;
  color: #797A7B !important;
  border: none;
}
.button:disabled:hover {
  box-shadow: none;
}
.button-default {
  outline: none !important;
  background-color: white;
  color: #5F96BA;
  border: 1px solid #5F96BA;
}
.button-default:hover {
  color: #284D76;
  background-color: #9FC6D8;
  border-color: #9FC6D8;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-active {
  background-color: #5F96BA;
  color: #FFF;
}
.button-active:hover {
  background-color: #9FC6D8;
  color: #284D76;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-disabled {
  background-color: #BCBCBD !important;
  color: white !important;
  border: none;
}
.button-disabled:hover {
  box-shadow: none;
}
.button-gradient {
  outline: none !important;
  background-image:
    linear-gradient(
      270deg,
      #171C8F,
      #00B7BD);
  color: white;
  border: none;
}
.button-gradient:hover {
  outline: none !important;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
@media screen and (max-width: 1000px) {
  .button {
    width: 275px;
    font-size: 15px;
  }
}
.cbm-item {
  padding: 10px;
  margin: 5px;
}
.cbm-item:hover {
  background-color: #EEEEEE;
}
.cmb-circle {
  background-color: #404040;
  width: 45px;
  height: 45px;
  border-radius: 45px;
  overflow: hidden;
}
.cbm-detail {
  flex: 1;
  padding-left: 15px;
}
.detail-recommend {
  font-size: 13px;
}
.detail-name {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}
.detail-tags {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
}
.detail-tags div {
  font-size: 13px;
  color: #9A9B9C;
  border: 1px solid #9A9B9C;
  padding: 2px 5px;
  margin: 2px;
  border-radius: 3px;
}
.detail-view {
  text-decoration: underline;
  cursor: pointer;
}
.star {
  height: 25px;
  width: 25px;
}
.star-active {
  opacity: 1;
}
.star-inactive {
  opacity: 0.2;
}
/*# sourceMappingURL=cbm-selector-item.component.css.map */
